import { JSX } from 'react';

import { GitHubActionsIcon } from './GitHubActionsIcon';
import { AwsIcon } from './AwsIcon';
import { BackstageIcon } from './BackstageIcon';
import { BackendIcon } from './BackendIcon';
import { KubernetesIcon } from './KubernetsIcon';
import WebIcon from '@mui/icons-material/Web';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DocumentationIcon from '@mui/icons-material/AutoStories';
import EngineeringIcon from '@mui/icons-material/Engineering';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import BugReportIcon from '@mui/icons-material/BugReport';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { BlueBoxIcon } from './BlueBoxIcon';

export const CATEGORY_ICONS: Record<string, JSX.Element> = {
  cicd: <GitHubActionsIcon />,
  infrastructure: <AwsIcon />,
  catalog: <BackstageIcon />,
  backend: <BackendIcon />,
  kubernetes: <KubernetesIcon />,
  seamless: <WebIcon />,
  documentation: <DocumentationIcon />,
  bluebox: <BlueBoxIcon />,
  aiecosystem: <AutoAwesomeIcon />,
  'software-engineering-excellence': <EngineeringIcon />,
  monitoring: <MonitorHeartIcon />,
  qa: <BugReportIcon />,
  mic: <DirectionsCarIcon />,
};
